import { render, staticRenderFns } from "./PagesReviewSlideshowWidget.vue?vue&type=template&id=6ac22666&"
import script from "./PagesReviewSlideshowWidget.vue?vue&type=script&lang=js&"
export * from "./PagesReviewSlideshowWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports